import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import * as React from "react";
import CheckIcon from "@material-ui/icons/Check";
import CrossIcon from "@material-ui/icons/Close";
import { SvgIcon } from "@material-ui/core";
import YESMoodGoodIcon from "@material-ui/icons/Mood";
import NOMoodBadIcon from "@material-ui/icons/MoodBad";
import CommentIcon from "@material-ui/icons/Comment";
import ThumbsUpIcon from "@material-ui/icons/ThumbUp";
import ThumbsDownIcon from "@material-ui/icons/ThumbDown";
import DigitsIcon from "@material-ui/icons/Dialpad";
import TuneIcon from "@material-ui/icons/Tune";
import EmptyIcon from "@material-ui/icons/Image";
const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginRight: 10,
    },
  });
interface Props extends WithStyles<typeof styles> {
  typeKey: any;
  feedBack: any;
  responseType?: any;
  style?: any;
  questionItem?: any;
}

function RightFingerIcon(props: any) {
  return (
    <SvgIcon viewBox="0 0 512 512" {...props}>
      <g>
        <g>
          <path
            fill={props.fillcolor}
            d="M48,175.999H16c-8.832,0-16,6.368-16,14.24v227.552c0,7.84,7.168,14.208,16,14.208h32c8.832,0,16-6.368,16-14.24V190.207
			C64,182.367,56.832,175.999,48,175.999z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill={props.fillcolor}
            d="M480,175.999H242.88l48.96-38.944c14.08-10.88,16.32-31.04,5.12-44.8c-10.88-14.08-31.04-16.352-44.8-5.12L96,196.767
			v213.056c11.744,13.44,28.832,22.176,48,22.176h160c17.6,0,32-14.4,32-32c0-17.6-14.4-32-32-32h16c17.664,0,32-14.336,32-32
			s-14.336-32-32-32h16c17.664,0,32-14.336,32-32s-14.336-32-32-32h144c17.6,0,32-14.4,32-32C512,190.399,497.6,175.999,480,175.999
			z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

class ResponseTypeComponent extends React.Component<Props> {
  state = {
    indexSelected: -1,
  };

  getResponseTypeIcon = () => {
    let typeKey = this.props.typeKey;
    let positiveColor =
      this.props.responseType && this.props.responseType.response
        ? this.props.responseType.response.positiveColor
        : "black";
    let negativeColor =
      this.props.responseType && this.props.responseType.response
        ? this.props.responseType.response.negativeColor
        : "black";
    if (!typeKey) {
      return null;
    }
    if (
      typeKey === "CHECK_1" ||
      typeKey === "CHECK_2" ||
      typeKey === "CHECK_3" ||
      typeKey === "CHECK_4"
    ) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <CheckIcon
            style={{ margin: 5, color: positiveColor }}
            fontSize={"small"}
          />
          <CrossIcon
            style={{ margin: 5, color: negativeColor }}
            fontSize={"small"}
          />
        </div>
      );
    }
    if (typeKey === "CHECK_5" || typeKey === "CHECK_7") {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <CheckIcon
            style={{ margin: 5, color: positiveColor }}
            fontSize={"small"}
          />
          <EmptyIcon
            style={{
              margin: 5,
              color: "transparent",
              backgroundColor: "transparent",
            }}
            fontSize={"small"}
          />
        </div>
      );
    }
    if (typeKey === "CHECK_6" || typeKey === "CHECK_8") {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <CrossIcon
            style={{ margin: 5, color: negativeColor }}
            fontSize={"small"}
          />
          <EmptyIcon
            style={{
              margin: 5,
              color: "transparent",
              backgroundColor: "transparent",
            }}
            fontSize={"small"}
          />
        </div>
      );
    }
    if (
      typeKey === "INTERACTIVE_1" ||
      typeKey === "INTERACTIVE_2" ||
      typeKey === "INTERACTIVE_3" ||
      typeKey === "INTERACTIVE_4"
    ) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <ThumbsUpIcon
            style={{ margin: 5, color: positiveColor }}
            fontSize={"small"}
          />
          <ThumbsDownIcon
            style={{ margin: 5, color: negativeColor }}
            fontSize={"small"}
          />
        </div>
      );
    }
    if (typeKey === "INTERACTIVE_5" || typeKey === "INTERACTIVE_7") {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <ThumbsUpIcon
            style={{ margin: 5, color: positiveColor }}
            fontSize={"small"}
          />
          <EmptyIcon
            style={{
              margin: 5,
              color: "transparent",
              backgroundColor: "transparent",
            }}
            fontSize={"small"}
          />
        </div>
      );
    }
    if (typeKey === "INTERACTIVE_6" || typeKey === "INTERACTIVE_8") {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          <ThumbsDownIcon
            style={{ margin: 5, color: negativeColor }}
            fontSize={"small"}
          />
          <EmptyIcon
            style={{
              margin: 5,
              color: "transparent",
              backgroundColor: "transparent",
            }}
            fontSize={"small"}
          />
        </div>
      );
    }
    switch (typeKey) {
      case "TEXT":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <YESMoodGoodIcon
              style={{ margin: 5, color: positiveColor }}
              fontSize={"small"}
            />
            <NOMoodBadIcon
              style={{ margin: 5, color: negativeColor }}
              fontSize={"small"}
            />
          </div>
        );

      case "TEXT_2":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <YESMoodGoodIcon
              style={{ margin: 5, color: positiveColor }}
              fontSize={"small"}
            />
            <EmptyIcon
              style={{
                margin: 5,
                color: "transparent",
                backgroundColor: "transparent",
              }}
              fontSize={"small"}
            />
          </div>
        );
      case "TEXT_3":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <NOMoodBadIcon
              style={{ margin: 5, color: negativeColor }}
              fontSize={"small"}
            />
            <EmptyIcon
              style={{
                margin: 5,
                color: "transparent",
                backgroundColor: "transparent",
              }}
              fontSize={"small"}
            />
          </div>
        );

      case "COMMENT":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <CommentIcon style={{ margin: 5 }} fontSize={"small"} />
            <EmptyIcon
              style={{
                margin: 5,
                color: "transparent",
                backgroundColor: "transparent",
              }}
              fontSize={"small"}
            />
          </div>
        );
      case "NUMERIC":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <DigitsIcon style={{ margin: 5 }} fontSize={"small"} />
            <EmptyIcon
              style={{
                margin: 5,
                color: "transparent",
                backgroundColor: "transparent",
              }}
              fontSize={"small"}
            />
          </div>
        );
      case "Options": {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <TuneIcon
              style={{ margin: 5, color: negativeColor }}
              fontSize={"small"}
            />
            <EmptyIcon
              style={{
                margin: 5,
                color: "transparent",
                backgroundColor: "transparent",
              }}
              fontSize={"small"}
            />
          </div>
        );
      }
    }
  };

  getResponseIcon = () => {
    let typeKey = this.props.typeKey;
    let positiveColor =
      this.props.responseType && this.props.responseType.response
        ? this.props.responseType.response.positiveColor
        : "black";
    let negativeColor =
      this.props.responseType && this.props.responseType.response
        ? this.props.responseType.response.negativeColor
        : "black";
    if (!typeKey) {
      return null;
    }
    let response = this.props.questionItem.value.response;
    switch (typeKey) {
      case "CHECK_1":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "GO" && (
              <CheckIcon
                style={{ margin: 5, color: positiveColor }}
                fontSize={"small"}
              />
            )}
            {response === "NO-BUT" && (
              <CrossIcon
                style={{ margin: 5, color: negativeColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "CHECK_2":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "GO" && (
              <CheckIcon
                style={{ margin: 5, color: positiveColor }}
                fontSize={"small"}
              />
            )}
            {response === "NO-GO" && (
              <CrossIcon
                style={{ margin: 5, color: negativeColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "CHECK_3":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "YES" && (
              <CheckIcon
                style={{ margin: 5, color: positiveColor }}
                fontSize={"small"}
              />
            )}
            {response === "NO" && (
              <CrossIcon
                style={{ margin: 5, color: negativeColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "CHECK_4":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "GO" && (
              <CheckIcon
                style={{ margin: 5, color: positiveColor }}
                fontSize={"small"}
              />
            )}
            {response === "NO-OK" && (
              <CheckIcon
                style={{ margin: 5, color: negativeColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "CHECK_5":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "GO" && (
              <CheckIcon
                style={{ margin: 5, color: positiveColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "CHECK_6":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "NO-GO" && (
              <CrossIcon
                style={{ margin: 5, color: negativeColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "CHECK_7":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "OK" && (
              <CheckIcon
                style={{ margin: 5, color: positiveColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "CHECK_8":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "NO-OK" && (
              <CrossIcon
                style={{ margin: 5, color: negativeColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "TEXT":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "YES" && (
              <YESMoodGoodIcon
                style={{ margin: 5, color: positiveColor }}
                fontSize={"small"}
              />
            )}
            {response === "NO" && (
              <NOMoodBadIcon
                style={{ margin: 5, color: negativeColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "INTERACTIVE_1":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "GO" && (
              <ThumbsUpIcon
                style={{ margin: 5, color: positiveColor }}
                fontSize={"small"}
              />
            )}
            {response === "GO-BUT" && (
              <RightFingerIcon
                style={{ margin: 2 }}
                fillcolor={negativeColor}
              />
            )}
          </div>
        );
      case "INTERACTIVE_2":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "GO" && (
              <ThumbsUpIcon
                style={{ margin: 5, color: positiveColor }}
                fontSize={"small"}
              />
            )}
            {response === "GO-BUT" && (
              <ThumbsDownIcon
                style={{ margin: 5, color: negativeColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "INTERACTIVE_3":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "GO" && (
              <ThumbsUpIcon
                style={{ margin: 5, color: positiveColor }}
                fontSize={"small"}
              />
            )}
            {response === "NO-GO" && (
              <ThumbsDownIcon
                style={{ margin: 5, color: negativeColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "INTERACTIVE_4":
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            {response === "YES" && (
              <ThumbsUpIcon
                style={{ margin: 5, color: positiveColor }}
                fontSize={"small"}
              />
            )}
            {response === "NO" && (
              <ThumbsDownIcon
                style={{ margin: 5, color: negativeColor }}
                fontSize={"small"}
              />
            )}
          </div>
        );
      case "Options": {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <TuneIcon
              style={{ margin: 5, color: negativeColor }}
              fontSize={"small"}
            />
          </div>
        );
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root} style={this.props.style}>
        {this.props.feedBack
          ? this.getResponseIcon()
          : this.getResponseTypeIcon()}
      </div>
    );
  }
}
export default withStyles(styles)(ResponseTypeComponent);
